export const FLAG_GETTING_HIERARCHIES = 'FLAG_GETTING_HIERARCHIES';
export const GET_HIERARCHIES = 'GET_HIERARCHIES';
export const CLEAR_HIERARCHIES = 'CLEAR_HIERARCHIES';
